import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import Timeline from '../Timeline';

const Audio = ({ mergedVideoPath }) => {
  return (
    <div className="p-4">
      <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4 flex" role="alert">
        <FaInfoCircle className="mr-2 mt-1" />
        <div>
          <p className="font-bold">Under Development</p>
          <p>This feature is currently under development and will be available soon.</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto">
        <div className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden">
          <video controls autoPlay loop muted src={mergedVideoPath} className="w-full h-full object-cover"></video>
        </div>
      </div>
      <div className="mt-4">
        <Timeline />
      </div>
    </div>
  );
};

export default Audio;
